import { CircularProgress } from '@material-ui/core';
import { Box } from '@mui/material';

type LoaderProps = {
    top: string,
    left: string,
}

export const Loader = ({ top, left }:LoaderProps): JSX.Element => {
  const style = {
    loader: {
      sx: {
        position: 'absolute',
        top,
        left,
      },
    },
  } as const;

  return (
    <Box sx={ style.loader.sx }>
      <CircularProgress />
    </Box>
  );
};
